import React, { useState } from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';

const phoneBack = process.env.PUBLIC_URL + '/galilaio/phone_back.png';

interface MobilePreviewProps {
    message: string;
    messageShortlink: string;
}

const MobilePreview: React.FC<MobilePreviewProps> = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.phoneContainer}>
            <img src={phoneBack} className={classes.phone} />
            <div className={classes.phoneMessage}>
                <div>{props.message}</div>
                <div className={classes.messageLink}>{props.messageShortlink}</div>
                <div className={classes.messageItem}>Stop to remove</div>
            </div>
        </div>
    );
}

export default MobilePreview;

const useStyles = makeStyles((theme) => ({
    phoneContainer: {
        position: 'relative'
    },
    phone: {
        width: 275,
        margin: '0px auto',
        display: 'block'
    },
    phoneMessage: {
        position: 'absolute',
        top: 100,
        left: 40,
        padding: 10,
        backgroundColor: '#EEF0F1',
        borderRadius: 4,
        width: 230
    },
    messageItem: {
        paddingTop: 10
    },
    messageLink: {
        color: '#00ABCA'
    }
}));


// WEBPACK FOOTER //
// ./src/pages/campaign/components/MobilePreview.tsx